import { IntRange } from '../../types';

export type DayOfWeek = IntRange<0, 6>;
export type Hour = IntRange<0, 23>;
export type Minute = IntRange<0, 59>;

export default class DateHelpers {
  public static dayNumberFromString(day: string): DayOfWeek {
    const dayNumber = {
      Su: 0,
      Sun: 0,
      Sunday: 0,
      Mo: 1,
      Mon: 1,
      Monday: 1,
      Tu: 2,
      Tue: 2,
      Tuesday: 2,
      We: 3,
      Wed: 3,
      Wednesday: 3,
      Th: 4,
      Thu: 4,
      Thursday: 4,
      Fr: 5,
      Fri: 5,
      Friday: 5,
      Sa: 6,
      Sat: 6,
      Saturday: 6,
    }[day] as DayOfWeek;

    if (dayNumber === null || dayNumber === undefined) {
      throw new Error(`Unknown day of week: ${dayNumber}`);
    }

    return dayNumber;
  }

  public static getNextDayNumber(day: DayOfWeek): DayOfWeek {
    return (day as number) === 6 ? 0 : ((day + 1) as DayOfWeek);
  }
}
